<template>
    <div class="info">
        <div class="my__blood-top">
            <div class="blood-calendar">
                <div class="blood-calendar__top">
                    <a href="javascript:;" class="blood-calendar--today" @click="todayCalendar">오늘</a>
                    <a href="javascript:;" class="blood-calendar--button prev" @click="prevCalendar"></a>
                    <h4 class="title02">{{calYear}}-{{calMonth}}</h4>
                    <a href="javascript:;" class="blood-calendar--button next" @click="nextCalendar"></a>
                </div>
                <table class="blood-calendar__body">
                    <caption> 예약일 선택 테이블 </caption>
                    <colgroup>
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>일</th>
                            <th>월</th>
                            <th>화</th>
                            <th>수</th>
                            <th>목</th>
                            <th>금</th>
                            <th>토</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- td classList - none: 지난달, 다음달 / on:  측정기록이 있는날 / active -->
                        <tr v-for="item in arrChunk(calendarList)" :key="item">
                            <td v-for="i in item" :key="i" :class="[i.dayType, {'active' : i.text == activeIndex}]">
                                <a href="javascript:;" @click="[selectDate(i.year, i.month, i.day, $event), activeIndex = i.text]">
                                    {{i.day}}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
               
                <div class="blood-calendar__bottom">
                    <div class="radio-wrap">
                        <label for="radio01" class="">
                            <input type="radio" id="radio01" class="agree-" name="radio01" value="ALL" v-model="selectHmCd"> 
                            <span class="radio-btn"></span>
                            <p>전체</p> 
                        </label>
                        <label for="radio02" class="">
                            <input type="radio" id="radio02" class="agree-" name="radio02" value="BP" v-model="selectHmCd">
                            <span class="radio-btn"></span> 
                            <p>혈압</p> 
                        </label>
                        <label for="radio03" class="">
                            <input type="radio" id="radio03" class="agree-" name="radio03" value="BS" v-model="selectHmCd">
                            <span class="radio-btn"></span> 
                            <p>혈당</p> 
                        </label>
                        <label for="radio04" class="">
                            <input type="radio" id="radio04" class="agree-" name="radio04" value="BM" v-model="selectHmCd">
                            <span class="radio-btn"></span> 
                            <p>체질량</p> 
                        </label>
                    </div>
                    <div class="blood-calendar__state">
                        <div class="blood-calendar__state__item">
                            <span></span>
                            기록
                        </div>
                        <div class="blood-calendar__state__item">
                            <span></span>
                            오늘
                        </div>
                    </div>
                </div>
            </div>
            <div class="blood-check">
                <h3 class="title02">{{$commonUtils.makeDateFormat(selectDay, '-')}} 측정결과</h3>
                <ul class="blood-check__list">
                    <li class="blood-check__item">
                        <h4 class="title02">혈압</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon01.svg" alt="">
                            </div>
                            <div class="con">
                                <div class="text" v-if="selectItem != null && selectItem.BP != null">
                                    <p><b>{{selectItem.BP.result}}</b></p>
                                    <p><b class="title02">{{selectItem.BP.record2}}~{{selectItem.BP.record1}}</b> mmHg</p>
                                </div>
                                <div class="text" v-else>
                                    <p>등록된 데이터가 없습니다</p>
                                </div>
                                <div class="botton-wrap">
                                    <a href="" class="main-button small c-gray" @click.prevent="goPage('/kr/mypage/health/bloodPressure')">혈압 등록</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="blood-check__item">
                        <h4 class="title02">혈당</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon02.svg" alt="">
                            </div>
                            <div class="con">
                                <div class="text" v-if="selectItem != null && selectItem.BS != null">
                                    <p><b>{{selectItem.BS.result}}</b></p>
                                    <p><b class="title02">{{selectItem.BS.record2}}</b> mg/dl</p>
                                </div>
                                <div class="text" v-else>
                                    <p>등록된 데이터가 없습니다</p>
                                </div>
                                <div class="botton-wrap">
                                    <a href="" class="main-button small c-gray" @click.prevent="goPage('/kr/mypage/health/bloodSugar')">혈당 등록</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="blood-check__item">
                        <h4 class="title02">체질량</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon03.svg" alt="">
                            </div>
                            <div class="con">
                                <div class="text" v-if="selectItem != null && selectItem.BM != null">
                                    <p><b>{{selectItem.BM.result}}</b></p>
                                    <p><b class="title02">{{Number(selectItem.BM.record3).toFixed(1)}}</b> kg/m²</p>
                                </div>
                                <div class="text" v-else>
                                    <p>등록된 데이터가 없습니다</p>
                                </div>
                                <div class="botton-wrap">
                                    <a href="" class="main-button small c-gray" @click.prevent="goPage('/kr/mypage/health/bodyMass')">체질량 등록</a>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="info">
        <div class="tab-menu-wrap">
            <ul class="tab-menu">
                <li class="tab-menu__item" :class="subHmCd == 'BP' ? 'active' : ''">
                    <a href="javascript:;" @click.prevent="changeSubPage('BP')">혈압</a>
                </li>
                <li class="tab-menu__item" :class="subHmCd == 'BS' ? 'active' : ''">
                    <a href="javascript:;" @click.prevent="changeSubPage('BS')">혈당</a>
                </li>
                <li class="tab-menu__item" :class="subHmCd == 'BM' ? 'active' : ''">
                    <a href="javascript:;" @click.prevent="changeSubPage('BM')">체질량</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="info">
        <h3 class="bullet01">변화 그래프</h3>
        <div class="table-search">
            <VueDatePicker v-model="selectedDateRange" locale="ko"
            :enable-time-picker="false" :format="customFormat"
            :week-start="0" :day-class="getDayClass"
            :select-text="'선택'" :cancel-text="'취소'"
            :range="true" :multi-calendars="true" placeholder="날짜를 선택하세요."/>
  
            <ul class="table-select__button-wrap">
                <li>
                    <a href="javascript:;" class="table-select--sub-btn" :class="period == 3 ? 'active' : ''" @click="changePeriod(3)">3개월</a>
                </li>
                <li>
                    <a href="javascript:;" class="table-select--sub-btn" :class="period == 6 ? 'active' : ''" @click="changePeriod(6)">6개월</a>
                </li>
                <li>
                    <a href="javascript:;" class="table-select--sub-btn" :class="period == 12 ? 'active' : ''" @click="changePeriod(12)">12개월</a>
                </li>
                <li>
                    <a href="javascript:;" class="table-select--sub-btn" :class="period == 24 ? 'active' : ''" @click="changePeriod(24)">24개월</a>
                </li>
            </ul>
        </div>
        <div class="blood-chart-wrap">
            <HealthChart :chartDataSet="chartDataSet" ref="HealthChart"/>
        </div>
    </div>
    <div class="info">
        <h3 class="bullet01">측정 상세정보</h3>

        <div class="table scroll">
            <div class="table__inner">
                <table v-show="subHmCd == 'BP'">
                    <colgroup>
                        <col style="width: 80px;">
                        <col style="width: 20%;">
                        <col style="width: 20%;">
                        <col style="width: ;">
                        <col style="width: ;">
                        <col style="width: ;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                               
                            </th>
                            <th>측정일자</th>
                            <th>측정시간</th>
                            <th>수축기혈압</th>
                            <th>이완기혈압</th>
                            <th>혈압상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="subDataList.BP.length == 0"><td colspan="6"><p>선택된 내용이 없습니다.</p></td></tr>
                        <tr v-for="(item, index) in subDataList.BP" :key="item.hmSn">
                            <td>
                                <div class="checkbox-wrap">
                                    <label>
                                        <input type="checkbox" name="test-check01" id="check01" :value="item.hmSn" v-model="dataDel">
                                        <span class="checkbox-btn"></span>
                                    </label>
                                </div>
                            </td>
                            <td>{{$commonUtils.makeDateFormat(item.logDay, '.')}}</td>
                            <td>{{item.logDt.split(" ")[1]}} {{item.logDt.split(" ")[2]}}</td>
                            <td>{{item.record1}}</td>
                            <td>{{item.record2}}</td>
                            <td>{{item.result}}</td>
                        </tr>
                    </tbody>
                </table>

                <table v-show="subHmCd == 'BS'">
                    <colgroup>
                        <col style="width: 80px;">
                        <col style="width: 20%;">
                        <col style="width: 20%;">
                        <col style="width: ;">
                        <col style="width: ;">
                        <col style="width: ;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                               
                            </th>
                            <th>측정일자</th>
                            <th>측정시간</th>
                            <th>식전혈당</th>
                            <th>식후혈당</th>
                            <th>혈당상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="subDataList.BS.length == 0"><td colspan="6"><p>선택된 내용이 없습니다.</p></td></tr>
                        <tr v-for="(item, index) in subDataList.BS" :key="item.hmSn">
                            <td>
                                <div class="checkbox-wrap">
                                    <label>
                                        <input type="checkbox" name="test-check02" id="check02" :value="item.hmSn" v-model="dataDel">
                                        <span class="checkbox-btn"></span>
                                    </label>
                                </div>
                            </td>
                            <td>{{$commonUtils.makeDateFormat(item.logDay, '.')}}</td>
                            <td>{{item.logDt.split(" ")[1]}} {{item.logDt.split(" ")[2]}}</td>
                            <td>{{item.record1 == '식전' ? item.record2 : ''}}</td>
                            <td>{{item.record1 == '식후' ? item.record2 : ''}}</td>
                            <td>{{item.result}}</td>
                        </tr>
                    </tbody>
                </table>

                <table v-show="subHmCd == 'BM'">
                    <colgroup>
                        <col style="width: 80px;">
                        <col style="width: 20%;">
                        <col style="width: 20%;">
                        <col style="width: ;">
                        <col style="width: ;">
                        <col style="width: ;">
                        <col style="width: ;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                               
                            </th>
                            <th>측정일자</th>
                            <th>측정시간</th>
                            <th>키</th>
                            <th>몸무게</th>
                            <th>BMI 지수</th>
                            <th>판정분류</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="subDataList.BM.length == 0"><td colspan="7"><p>선택된 내용이 없습니다.</p></td></tr>
                        <tr v-for="(item, index) in subDataList.BM" :key="item.hmSn">
                            <td>
                                <div class="checkbox-wrap">
                                    <label>
                                        <input type="checkbox" name="test-check03" id="check03" :value="item.hmSn" v-model="dataDel">
                                        <span class="checkbox-btn"></span>
                                    </label>
                                </div>
                            </td>
                            <td>{{$commonUtils.makeDateFormat(item.logDay, '.')}}</td>
                            <td>{{item.logDt.split(" ")[1]}} {{item.logDt.split(" ")[2]}}</td>
                            <td>{{item.record1}}</td>
                            <td>{{item.record2}}</td>
                            <td>{{Number(item.record3).toFixed(1)}}</td>
                            <td>{{item.result}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="botton-wrap">
            <a href="javascript:;" class="sub-button c-main" @click="delItems">삭제</a>
        </div>
    </div>
</template>

<script>
import { ref, onMounted  } from 'vue';
import HealthChart from '@/components/common/HealthChart.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
export default {
    components: {
        HealthChart,
        VueDatePicker,
    },
    data() {
        return {
            selectedDateRange: [new Date(), new Date()], // 날짜 선택값
            customFormat: 'yyyy-MM-dd',  // 날짜 포맷

            healthAllList: '',
            healthScheduleData: '',
            selectHmCd: 'ALL',


            // 캘린더
            classList: '',
            startDate: '',
            endDate: '',
            today: new Date(),
            calendarList: '',
            calYear: '',
            calMonth: '',
            activeIndex: '',

            toDay: this.$commonUtils.getToday(),
            selectDay: '',
            selectItem: {},
            hmCdList : ['BP', 'BS', 'BM'],
            subHmCd: 'BP',
            subDataList : {
				'BP' : [],
				'BS' : [],
				'BM' : []
			},
            period: 3,
            dataDel: [],

            chartDataSet: {},
        };
    },
    watch:{
		selectHmCd(){
            this.calendarList.forEach(obj => {
                obj.dayType = obj.dayType.replace(/\bon\b/g, '').trim();
            });

            const stringYear = this.calYear.toString()
            const stringMonth = this.calMonth.toString()
            this.calendarList.forEach(i => {
                if(i.year == stringYear && i.month == stringMonth){
                    const hasPos = this.healthScheduleData.some(j => {
                        if (this.selectHmCd === 'ALL') {
                            return i.text === j.date;
                        } else {
                            return i.text === j.date && j[this.selectHmCd] > 0;
                        }
                    });

                    if (hasPos) {
                        i.dayType += ' on';
                    }
                }
            });
		}
    },
    methods: {
        goPage(url){
            this.$store.commit('setBloodDate', new Date(this.$commonUtils.makeDateFormat(this.selectDay, '-')))
            this.$router.push(url)
        },
        setSelectedPeriod(months) {
            const startDate = new Date();
            const endDate = new Date();
            startDate.setMonth(startDate.getMonth() - months);
            this.selectedDateRange = [startDate, endDate];
        },
        getDayClass(date) {
            const day = date.getDay()
            if (day === 0) {
                return "sunday-class"
            } else if (day === 6) {
                return "saturday-class"
            }
            return ""
        },
        getList(){
            this.axios.get(this.api.mypage.healthList)
            .then(response => {
                let prevDate = '';
				this.healthAllList = response.data.result.list;
                this.healthScheduleData = []
                let arr = []
				this.healthAllList.forEach(item => {
                	if(prevDate !== item.logDay){
                		prevDate = item.logDay;
                		this.healthScheduleData.push( { 'date' : prevDate, 'BP' : 0, 'BS' : 0, 'BM' : 0 } );
                	}
                    const obj = {}
                    obj.text = item.logDay
                    obj.date = item.logDt
                    obj.dayType = 'on'
                    arr.push(obj)
                });
                this.classList = arr
				
				this.healthScheduleData.forEach(item => {
                	this.healthAllList.forEach(item2 => {
                		if(item.date == item2.logDay){
							if(item2.hmCd == 'BP'){
								item.BP =+ 1;
							}
							if(item2.hmCd == 'BS'){
								item.BS =+ 1;
							}
							if(item2.hmCd == 'BM'){
								item.BM =+ 1;
							}
                		}
                	});
                });

                if(this.classList){
                    for(let i of this.calendarList){
                        for(let j of this.classList){
                            if(i.text == j.text){
                                i.dayType += ` ${j.dayType}`
                            }
                        }
                    }
                }


                this.selectDay = this.toDay
                this.selectDate2(this.toDay)
                this.getChartList()

                const type = this.$route.query.type
                if(type){
                    this.$nextTick(()=>{
                        this.selectHmCd = type
                        this.changeSubPage(type)
                    })
                }
            });
        },
        selectDate(year, month, day, event){
            this.selectDate2(year + '' + month + '' + day, event);
        },
		selectDate2(_date, event){
			this.tempDay = _date;

            document.querySelectorAll('.blood-calendar__body  td').forEach(el => {
                el.classList.remove('active')
            })
            this.selectDay = this.tempDay;
            this.healthScheduleData.forEach(item => {
				if(this.tempDay === item.date){
					if(event){
						event.target.closest('td').classList.add('active');
					}else{
						document.querySelector('.today').classList.add('active');
					}
				}
			});

			this.selectItem = {};
			this.hmCdList.forEach(cd => {
				for(var i = 0; i < this.healthAllList.length; i++ ){
					if(this.selectDay == this.healthAllList[i].logDay && cd == this.healthAllList[i].hmCd){			
						this.selectItem[this.healthAllList[i].hmCd] = this.healthAllList[i];
						break;
					}
				}
			});
		},
        changePeriod(_period) {
		    this.period = _period;
			var startDate = new Date();
			var endDate = new Date();

			startDate.setMonth(startDate.getMonth() - this.period);

			this.selectedDateRange = [startDate, endDate];
		    this.getChartList();
		},   	
        getChartList(){
        	var searchParam = {
        		'inqrStrtYmd' : this.$commonUtils.dateToStr(this.selectedDateRange[0],''),
        		'inqrFnshYmd' : this.$commonUtils.dateToStr(this.selectedDateRange[1],'')
        	};

			this.subDataList = {
				'BP' : [],
				'BS' : [],
				'BM' : []
			};

			this.healthAllList.forEach(item => {
				if(searchParam.inqrStrtYmd <= item.logDay && searchParam.inqrFnshYmd >= item.logDay){
					if(item.hmCd == 'BP'){
						this.subDataList.BP.push(item);
					}
					if(item.hmCd == 'BS'){
						this.subDataList.BS.push(item);
					}
					if(item.hmCd == 'BM'){
						this.subDataList.BM.push(item);
					}
				}
			});

            this.chartDataSet.labels = []
            this.chartDataSet.record1 = []
            this.chartDataSet.record2 = []
            for(let i of this.subDataList[this.subHmCd].sort((a, b) => a.logDay - b.logDay)){
                this.chartDataSet.labels.push(this.$commonUtils.makeDateFormat(i.logDay, '.'))
                if(this.subHmCd == 'BM'){
                    this.chartDataSet.record1.push(Number(i.record3).toFixed(1))
                }else if(this.subHmCd == 'BS'){
                    if(i.record1 == '식전'){
                        this.chartDataSet.record1.push(i.record2)
                        this.chartDataSet.record2.push(null)
                    }else{
                        this.chartDataSet.record1.push(null)
                        this.chartDataSet.record2.push(i.record2)
                    }
                }else{
                    this.chartDataSet.record1.push(i.record1)
                    this.chartDataSet.record2.push(i.record2)
                }
            }
            this.chartDataSet.type = this.subHmCd
		},
        changeSubPage(_cd) {
			this.subHmCd = _cd;
			this.dataDel = [];
			this.changePeriod(3);
            // this.getChartList()
            this.$refs.HealthChart.selectedDataset = 'all'
		},
        delItems(){
			if(this.dataDel.length == 0){
				alert('삭제할 항목을 선택해주세요.');
				return false;
			}else{
				if(confirm('선택한 항목을 삭제하시겠습니까?')){
					this.axios({
						method:"post",
						url: this.api.mypage.healthDel, 
						params: { 'delSeq' : this.dataDel},
						paramsSerializer : function(paramObj) {
							const params = new URLSearchParams()
							for (const key in paramObj) {
								params.append(key, paramObj[key])
							}

							return params.toString();
						}
					}).then(response => {
						this.getList();
					});
				}
			}
		},

        /**
         * 이번 달의 첫 날, 마지막 날 구하기
         */
        init(){
            this.startDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
            this.endDate = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
            this.createCalendar();
        },
        /**
         * 달력 생성
         */
        createCalendar(){
            this.activeIndex = ''
            this.calendarList = [];
            this.calYear = this.today.getFullYear();
            this.calMonth = this.$commonUtils.leftPad(this.today.getMonth() + 1);

            if(this.startDate.getDay() > 0){
                let preLastSunDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), ((this.startDate.getDay() - 1) * -1));
                let preLastDate = new Date(preLastSunDate.getFullYear(), preLastSunDate.getMonth() + 1, 0);

                // 지난달 구하기
                for (let preDay = preLastSunDate; preDay <= preLastDate; preDay.setDate(preDay.getDate() + 1)) { 
                    let date = {
                        year : preDay.getFullYear(),
                        month : this.$commonUtils.leftPad(preDay.getMonth() + 1),
                        day : this.$commonUtils.leftPad(preDay.getDate()),
                        week : preDay.getDay(), // 0~6
                        text : this.$commonUtils.dateToStr(preDay, ''),
                        dayType : 'none'
                    }

                    this.calendarList.push(date);
                }
            }

            let today = new Date();
            today.setHours(0, 0, 0, 0); // 시간 초기화

            // 이번달 구하기
            for (let nowDay = this.startDate; nowDay <= this.endDate; nowDay.setDate(nowDay.getDate() + 1)) { 
                let date = {
                    year : nowDay.getFullYear(),
                    month : this.$commonUtils.leftPad(nowDay.getMonth() + 1),
                    day : this.$commonUtils.leftPad(nowDay.getDate()),
                    week : nowDay.getDay(),
                    text : this.$commonUtils.dateToStr(nowDay, ''),
                    dayType : ''
                }

                if (nowDay < today) {
                    // date.dayType = "pastDay";
                } else if (nowDay.getFullYear() == today.getFullYear() 
                            && nowDay.getMonth() == today.getMonth() && nowDay.getDate() == today.getDate()) {    
                    date.dayType = "today";
                }else {
                    // date.dayType = "futureDay";
                }

                this.calendarList.push(date);
            }
           
            // 다음달 구하기
            if(this.endDate.getDay() < 6){
                let nextFirstDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() + 1, 1);
                let nextFirstSunDate = new Date(nextFirstDate.getFullYear(), nextFirstDate.getMonth(), ((this.endDate.getDay() - 7 ) * -1) -1);
                
                for (let nextDay = nextFirstDate; nextDay <= nextFirstSunDate; nextDay.setDate(nextDay.getDate() + 1)) { 
                    let date = {
                        year : nextDay.getFullYear(),
                        month : this.$commonUtils.leftPad(nextDay.getMonth() + 1),
                        day : this.$commonUtils.leftPad(nextDay.getDate()),
                        week : nextDay.getDay(),
                        text : this.$commonUtils.dateToStr(nextDay, ''),
                        dayType : 'none'
                    }

                    this.calendarList.push(date);
                }
            }

            // dayType에 class 부여
            const stringYear = this.calYear.toString()
            const stringMonth = this.calMonth.toString()
            if(this.classList){
                for(let i of this.calendarList){
                    for(let j of this.classList){
                        if(i.text == j.text && i.year == stringYear && i.month == stringMonth){
                            i.dayType += ` ${j.dayType}`
                        }
                    }
                }
            }
        },
        todayCalendar(){
            this.today = new Date();
            this.init();
            this.selectDay = this.toDay
            this.selectDate2(this.toDay)
        },
        prevCalendar(){
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1);
            this.selectHmCd = 'ALL'
            this.init();
        },
        nextCalendar(){
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);
            this.selectHmCd = 'ALL'
            this.init();
        },
        arrChunk(arr){
            return arr.reduce(function (acc, val, index) {
                const chunkIndex = Math.floor(index / 7);
                if (!acc[chunkIndex]) {
                    acc[chunkIndex] = [];
                }
                acc[chunkIndex].push(val);
                return acc;
            }, []);
        },
    },
    created() {
        this.init();
        this.getList()
    },
    mounted() {
        this.setSelectedPeriod(3)

        // 테이블의 .table에 클릭 이벤트를 추가
        const tables = document.querySelectorAll('.table');

        tables.forEach((table) => {
            // .table 요소의 가상 요소 부분을 클릭한 것처럼 처리할 수 있게,
            // 테이블의 `::before`가 클릭될 수 있는 영역을 감싸는 영역을 클릭 이벤트로 처리
            table.addEventListener('click', () => {
                // 테이블에 'active' 클래스를 토글
                table.classList.add('active');
            });
        });
    },
}
</script>

<style scoped></style>